// export const SERVER_API_URL = "http://13.213.49.171/"
export const SERVER_API_URL = "https://service-mstc.herokuapp.com/"
// export const SERVER_API_URL = "http://localhost:8000/"